import { createSimpleFunctional } from '@/utils'

export const UExampleSimpleComponent = createSimpleFunctional(
  'u-example-simple-component'
)

export type UExampleSimpleComponent = InstanceType<
  typeof UExampleSimpleComponent
>
